import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, Icon, Input as ChakraInput, InputGroup, InputRightElement, useMultiStyleConfig, } from '@chakra-ui/react';
import { merge, omit } from 'lodash';
import { BxsCheckCircle } from '../icons/BxsCheckCircle';
export const Input = forwardRef((props, ref) => {
    const inputStyles = useMultiStyleConfig('Input', props);
    // Omit extra props so they will not be passed into the DOM and trigger
    // React warnings.
    const inputProps = omit(props, ['isSuccess', 'isPrefilled']);
    // Return normal input component if not success state.
    if (!props.isSuccess) {
        return _jsx(ChakraInput, { ref: ref, __css: inputStyles.field, ...inputProps });
    }
    return (
    // InputGroup is required for InputRightElement to retrieve the correct
    // style props. Will crash if not included.
    _jsxs(InputGroup, { children: [_jsx(ChakraInput, { ref: ref, sx: merge({}, inputStyles.field, props.sx), ...inputProps }), _jsx(InputRightElement, { sx: inputStyles.success, children: _jsx(Icon, { as: BxsCheckCircle }) })] }));
});
/**
 * This is used in by Chakra's `InputGroup` component to remove border radii
 * when paired with `InputLeftAddon` or `InputRightAddon`.
 *
 * See https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/input/src/input.tsx#L70 and
 * https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/input/src/input-group.tsx#L71.
 */
Input.id = 'Input';
Input.displayName = 'Input';
